import { Box, FormControl, MenuItem, Select, Typography } from '@mui/material'
import { useEffect } from 'react'
/**
 * The SerialNumberFilter component
 * @component
 *
 * @param {Object} props
 * @param {function} props.handleChangeNumSerie
 * @param {Array} props.purchasingOrganizations
 * @param {boolean} props.selector_loading
 * @returns {JSX.Element}
 */

const PurchasingOrganizationFilter = ({
  purchaseOrg,
  handlePurchasingOrg,
  purchasingOrganizations,
  selector_loading,
}) => {
  useEffect(() => {
    if (!selector_loading && purchasingOrganizations?.length === 1) {
      handlePurchasingOrg(purchasingOrganizations[0].codigo_org_compras)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [purchasingOrganizations])

  return (
    !selector_loading &&
    purchasingOrganizations?.length !== 1 && (
      <Box sx={{ width: '100%' }}>
        <FormControl sx={{ width: '49.5%' }}>
          <Typography variant="body1">Organización compras</Typography>

          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={purchaseOrg || 'ALL'}
            placeholder="Seleccione una organización de compras..."
            label="Organización compras"
            onChange={(e) => {
              handlePurchasingOrg(e.target.value === 'ALL' ? '' : e.target.value)
            }}
            sx={{
              '& .MuiOutlinedInput-notchedOutline': {
                display: 'none',
              },
            }}
          >
            <MenuItem key={'All'} value={'ALL'}>
              Todas
            </MenuItem>
            {!selector_loading &&
              purchasingOrganizations.map((item) => (
                <MenuItem key={item.codigo_org_compras} value={item.codigo_org_compras}>
                  {item.nombre}
                </MenuItem>
              ))}
          </Select>
        </FormControl>
      </Box>
    )
  )
}

export default PurchasingOrganizationFilter
